import { Component, Input, OnInit, OnDestroy, inject } from '@angular/core';
import { appReducer, documentSelectors, documentActions } from '@app-root-store';
import { Store, select } from '@ngrx/store';
import { IFolderTree } from '../../../main/interfaces/folder-tree.interface';
import { take, takeUntil } from 'rxjs/operators';
import { ModalRef } from '@siemens/element-ng/modal';
import { SiToastNotificationService } from '@siemens/element-ng/toast-notification';
import { Subject } from 'rxjs';
import { FolderStateEventArgs, MenuItemsProvider, TreeItem } from '@siemens/element-ng/tree-view';

@Component({
    selector: 'app-folder-select',
    templateUrl: './folder-select.component.html',
    styleUrls: ['./folder-select.component.scss'],
    standalone: false
})
export class FolderSelectComponent implements OnInit, OnDestroy {
    private store$ = inject<Store<appReducer.AppState>>(Store);
    modalRef = inject(ModalRef);
    private toastNotificationService = inject(SiToastNotificationService);

    private destroy$ = new Subject<boolean>();
    private drive$ = this.store$.pipe(select(documentSelectors.selectDocumentDrive));

    public treeItems: TreeItem[] = [];

    @Input() public data: { edit: boolean };

    public contextMenuItems: MenuItemsProvider = (item: TreeItem) => [
        {
            title: 'Auswählen',
            icon: 'element-plus',
            action: () => this.selectFolder(item)
        }
    ];

    ngOnInit() {
        if (!this.data || this.data.edit === null || this.data.edit === undefined) {
            this.toastNotificationService.queueToastNotification('danger', 'Error', 'An error has occurred');
            this.modalRef.hide();
            return;
        }

        this.store$
            .pipe(select(documentSelectors.selectDocumentFolderTreeForFolderSelect), takeUntil(this.destroy$))
            .subscribe((item) => {
                this.treeItems = item ? this.mapFolderTree(item.childs) : [];
            });
    }

    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }

    private mapFolderTree(folders: IFolderTree[]): TreeItem<IFolderTree>[] {
        return folders.map((f) => ({
            label: f.name,
            icon: 'element-folder',
            state: 'collapsed' as const,
            customData: f,
            children: f.childs?.length > 0 ? this.mapFolderTree(f.childs) : []
        }));
    }

    public onFolderClicked(event: FolderStateEventArgs) {
        const folder = event.treeItem?.customData as IFolderTree;
        if (folder) {
            this.store$.dispatch(documentActions.getFolder({ key: folder.id }));
        }
    }

    private selectFolder(item: TreeItem<IFolderTree>) {
        this.modalRef.hide({ type: 'folder', payload: item.customData });
    }

    public addDrive() {
        this.drive$.pipe(take(1)).subscribe((drive) => {
            this.modalRef.hide({ type: 'drive', payload: drive });
        });
    }
}
